import { render } from "./PersonWeaponTable.vue?vue&type=template&id=8fbb91ce&scoped=true"
import script from "./PersonWeaponTable.vue?vue&type=script&lang=js"
export * from "./PersonWeaponTable.vue?vue&type=script&lang=js"

import "./PersonWeaponTable.vue?vue&type=style&index=0&id=8fbb91ce&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbb91ce"]])

export default __exports__